import calculateChoiceSetTotals from './calculateChoiceSetTotals';

const calculateMIAMChoiceSetTotalPrice = (
  set: ValidatedChoiceSet | ValidatedNestedChoiceSet | undefined,
  quantity: number = 0,
  orderingMethod: ChoiceOrderingMethod,
): ChoiceSetTotals => {
  let result: ChoiceSetTotals = {
    moneyPrice: 0,
    pointsPrice: 0,
    pointsAward: 0,
  };
  if (set === undefined) return result;
  if (!set.choices || !(set.choices.length > 0)) return result;
  for (const choice of set.choices) {
    //only one choice can be in miam choiceset so far
    if (!(set.free > 0)) {
      result.moneyPrice += choice.moneyPrice;
      result.pointsAward += choice.basePointsAward;
      result.pointsPrice += choice.basePointsPrice;
    }
    if ('choiceSets' in choice && choice.choiceSets.length > 0) {
      for (const _set of choice.choiceSets) {
        const total = calculateChoiceSetTotals(_set, orderingMethod);
        result.moneyPrice += total.moneyPrice;
        result.pointsAward += total.pointsAward;
        result.pointsPrice += total.pointsPrice;
      }
    }
  }
  result.moneyPrice *= quantity;
  result.pointsAward *= quantity;
  result.pointsPrice *= quantity;
  return result;
};

export default calculateMIAMChoiceSetTotalPrice;
